import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-error" }
const _hoisted_2 = { class: "dialog-error__content" }
const _hoisted_3 = { class: "dialog-error__text" }
const _hoisted_4 = { class: "dialog-error__button" }

import { onMounted } from "vue";
import {useStore} from "vuex";

interface Props {
  error: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthenticationError',
  props: {
    error: {}
  },
  setup(__props: any) {

const store = useStore();



const back = () => {
  store.commit('user/setError', '')
}

onMounted(() => {
  store.commit('user/setLoader', false)
})

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!
  const _component_vita_button = _resolveComponent("vita-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "dialog-error__title" }, "Ошибка", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vita_icon, { name: "big-cross" }),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.error), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_vita_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back())),
          type: "small",
          "data-qa": "auth-error-button-back"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Вернуться", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})